export function getDaysAgo(dateStr: string): number {
  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const reported = new Date(`${dateStr}T00:00:00`);
  return Math.floor((today.getTime() - reported.getTime()) / 86400000);
}
